export default "__VITE_ASSET__z0Q_GbGB__"